import { render, staticRenderFns } from "./CardStatisticAvailable.vue?vue&type=template&id=fd4c1cde"
import script from "./CardStatisticAvailable.vue?vue&type=script&lang=js"
export * from "./CardStatisticAvailable.vue?vue&type=script&lang=js"
import style0 from "./CardStatisticAvailable.vue?vue&type=style&index=0&id=fd4c1cde&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports